import i18n from '../i18n';
import config from '../config';

export const ROUTE_ROOT = '/';
export const ROUTE_ECLAIMS = '/';
export const ROUTE_INSURERS = '/insurers';
export const ROUTE_CONFIRMATION = '/thanks';

export const getAbsoluteRouteForCurrentHost = (route: string) => {
    return (
        (i18n.language === 'fr'
            ? config.DOMAIN_FR
            : config.DOMAIN_EN) +
        route
    );
}
